import { DEFAULT_LOGO, getBranding, HEADER_LOGO, isDefaultLogo, MENU_LOGO } from '@/lib/branding'
import { cn } from '@/lib/utils'

/**
 * Logo thương hiệu. `variant="header"` (header nhỏ, nền sáng): bản ngang gọn; `variant="menu"` (menu trái, không khung): bản chữ xanh đen — khi đang dùng logo mặc định;
 * logo riêng do Platform tải lên thì dùng nguyên logo đó. Mặc định `full` (đăng nhập, trang lớn).
 */
export function BrandLogo({ className, imgClassName, showText = true, variant = 'full' }: { className?: string; imgClassName?: string; showText?: boolean; variant?: 'full' | 'header' | 'menu' }) {
  const b = getBranding()
  // Logo mặc định (kể cả giá trị cũ logo-ecdp.png còn lưu) → logo mới; logo riêng do Platform tải lên → giữ nguyên.
  const src = isDefaultLogo(b.logoUrl) ? (variant === 'menu' ? MENU_LOGO : variant === 'header' ? HEADER_LOGO : DEFAULT_LOGO) : b.logoUrl
  return (
    <div className={cn('flex items-center gap-2', className)}>
      <img
        src={src}
        alt={b.brandName}
        className={cn('h-8 w-auto max-w-[140px] object-contain', imgClassName)}
        onError={(e) => {
          ;(e.currentTarget as HTMLImageElement).style.display = 'none'
        }}
      />
      {showText && !b.logoUrl && <span className="text-lg font-bold">{b.brandName}</span>}
    </div>
  )
}
